import React from 'react';
import Widget from '../horizontalWidget';

const CategoryWidget2 = (props) => {
  return (
    <div>
      <Widget cardType={2} {...props} />
    </div>
  );
};

export default CategoryWidget2;
